import { makeStyles } from "tss-react/mui";
import { themeCore } from "../../../assets/themes/theme";
/**
 * Surface of the documents card drawn by `FormDocumentsDownloadAFY` (design system 100.2.84,
 * `box` class of the block). The block exposes neither children nor a footer/className, so the
 * section paints the same surface itself and hosts the block plus the polling status inside it.
 */
var DOCUMENTS_CARD_RADIUS = "12px";
var DOCUMENTS_CARD_SHADOW = "0px 0px 12px 0px rgba(204, 204, 204, 0.20)";
/** Horizontal padding of the DS card; its document list is a 70% column centered in it. */
var DOCUMENTS_CARD_PADDING_X = "20px";
var DOCUMENTS_LIST_WIDTH = "70%";
export var useCertificatesSectionStyles = makeStyles()(function () { return ({
    card: {
        backgroundColor: themeCore.colors.background,
        borderRadius: DOCUMENTS_CARD_RADIUS,
        boxShadow: DOCUMENTS_CARD_SHADOW,
        // The block renders `Grid container > Grid item > div.box` and paints its own shadow;
        // dropping it leaves the wrapper as the only card the user sees.
        "& > .MuiGrid-container > .MuiGrid-item > div": {
            boxShadow: "none",
        },
    },
    footer: {
        padding: "0 ".concat(DOCUMENTS_CARD_PADDING_X),
    },
    // Same column as the document list so the status reads as one more row of it.
    status: {
        width: DOCUMENTS_LIST_WIDTH,
        margin: "0 auto",
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: themeCore.spacing.spacingXs,
        padding: "".concat(themeCore.spacing.spacingTiny, " 0 ").concat(themeCore.spacing.spacingMedium),
        fontSize: themeCore.typography.fontSizeSm,
        lineHeight: "16px",
        color: themeCore.colors.secondaryText,
    },
    spinner: {
        display: "inline-flex",
        flexShrink: 0,
        color: themeCore.colors.primaryText,
    },
}); });
